//react imports
import React from 'react';

//css imports
import './App.css';

//external componets imports
import InputDetails from './InputDetails/InputDetails';
import OutputDetails from './OutputDetails/OutputDetails';
import Item from '../Model/item';
import Loader from '../Components/UI/Loader/Loader';


//external libraries imports
import axiosInstance from '../axiosSaveToServerInstance'; 







class App extends React.Component{
    state={
        queries:[
            {queryID:'id',queryName:'ID',queryDetails:{type:'number'}},
            {queryID:'name',queryName:'Product Name',queryDetails:{type:'text'}},
            {queryID:'imgUrl',queryName:'URL Image',queryDetails:{type:'url'}}
        ],
        
        itemsArray:[],
        toDelete:[],
        toUpdate:[],
        //dataSent:false,
        sendingReciving:false,
        updateItem:null



    }
    addItemToArray=(itemObject)=>{
        console.log("itemObj as in addItemToArray",itemObject)
        let newItemsArray=[...this.state.itemsArray];
        newItemsArray.push(itemObject);
        console.log("newItemArray is",newItemsArray);
        this.setState({itemsArray:newItemsArray});
        console.log("addItemToArray state.itemsArray & state ",this.state.itemsArray,this.state);

        
    }
    deleteItems(){
        console.log("inside del",this.state.itemsArray);
        let itemArrayCopy=[
            ...this.state.itemsArray
        ];
        itemArrayCopy=itemArrayCopy.filter(item => !item.markForDelete);
        console.log("itemarraycopy",itemArrayCopy);
        this.setState({itemsArray:itemArrayCopy});
        console.log("[App.js] deleteItems after delete",this.state.itemsArray);


    }
    searchById(id){
       // let itemArray = [];
        return this.state.itemArray.filter(item => item.id==id)[0];
    } 
    
    saveLocal(){
        let jsonItemArray = JSON.stringify(this.state.itemsArray);
        localStorage.setItem("itemArray",jsonItemArray);
        console.log("Saved to local storage as",localStorage);
    }
    loadLocalStorage(){
        console.log("inside loadLocal");
        let itemArrayString = localStorage.getItem('itemArray');
        console.log("loadLocal itemArrayString",itemArrayString);
        let itemArrayNew = JSON.parse(itemArrayString);
        console.log("loadLocal itemArray",itemArrayNew);
        itemArrayNew = itemArrayNew.map(item => {
            console.log("inside map",item)
                return ( new Item(item.id,item.name,item.url) );
        });
        console.log("loadLocal itemArray",itemArrayNew);
        this.setState({itemsArray : itemArrayNew});
        console.log("loadLocal itemArray",itemArrayNew);

    }
    clearLocal(){
        localStorage.clear();
    }
    saveToServer(){

        this.setState({sendingReciving:true});

        let itemInStore ={ items:this.state.itemsArray  };
        
        axiosInstance.post('itemsInStore.json',itemInStore).then(response=>{console.log("response",response);
            this.setState({sendingReciving:false});
        }).catch(error=>console.log("error",error));
    }
    loadFromServer(){
        this.setState({sendingReciving:true});
        axiosInstance.get('https://crudreact-f6975.firebaseio.com/itemsInStore.json').then(response=>{
            console.log(response);
            this.setState({sendingReciving:false});
           // this.setState({itemsArray:response.data});
        })
    }
    updateItem(itemObject){
        this.setState({updateItem:itemObject})
    }
    render(){
        //console.log("[App.js] itemArray",this.state.itemsArray);
        return (
            <div className="App">
                <h1>{this.props.title}</h1>
                <hr/>
                <InputDetails queries={this.state.queries} 
                    addItem={this.addItemToArray} deleteItems={this.deleteItems.bind(this)} saveLocal={this.saveLocal.bind(this)}
                    loadLocal={this.loadLocalStorage.bind(this)}
                    clearLocal={this.clearLocal.bind(this)}
                    saveToServer={this.saveToServer.bind(this)}
                    loadFromServer={this.loadFromServer.bind(this)}
                    itemObject={this.state.updateItem}
                    updateItem={this.updateItem.bind(this)}
                    />
                {
                    (this.state.sendingReciving)?(<Loader/>):null
                }
                <hr/>
                <OutputDetails itemArray={this.state.itemsArray} />
            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/Containers/App.js